import React from 'react';
import './Generallyinclude.css';
import Generally from '../../../imgs/Generallyinc.webp';

const Generallyinclude = () => {
    return (
        <div className="Generallyin-container">
            <div className='Cavitys'>
                <h2 className="Generallyin-title">The types of PET preforms generally include the following:</h2>
                <p className="Generallyin-date">PCO Preforms:</p>
                <p className="Generallyin-tex">
                    Manufacture of PET bottles for packaging carbonated soft drinks and
                    non-carbonated beverages such as juice, and milk. The neck size of the preform is
                    typically 28mm in diameter and comes in a wide range of weights, ranging from 12
                    grams to 54 grams.</p>
                <p className="Generallyin-date">CTC Preforms:</p>
                <p className="Generallyin-tex">Usually made for packaging cooking oil and soy sauce. These preforms can be used
                    to make PET bottles that can hold one liter of cooking oil. The neck diameter is 29mm.</p>
                <p className="Generallyin-date">Alaska Preforms:</p>
                <p className="Generallyin-tex">Commonly used to make PET bottles for drinking water. Standard neck diameters for Alaskan preforms
                    are 26 to 28 mm. They can be used to make pet containers that can hold 2 liters of drinking water.</p>
                <p className="Generallyin-date">ROPP Preforms:</p>
                <p className="Generallyin-tex">Manufacturing PET bottles for pharmaceutical applications. Their neck diameter is 28MM. ROPP bottles have
                    roll-on caps that can be applied automatically on the assembly line.</p>
                <p className="Generallyin-date">Other Special Types:</p>
                <p className="Generallyin-tex">For 20-liter/5-gallon water bottles: the diameter is generally 55-56mm, and the weight is generally: 670g-720g.</p>
                <p className="Generallyin-date">Wide mouth food jars:</p>
                <p className="Generallyin-tex"> the diameter of the bottle mouth is generally 80mm-120mm, and the weight is 30g-95g.</p>
                <div className="Generallyin">
                    <img src={Generally} alt="72 Generallyin PET Preforms Machine" className="Generallyin-image" />
                    <div className="Generallyin-content">

                        <p className="Generallyin-text"> Disha is committed to providing customers with multi-cavity preform injection molding solutions to help achieve higher productivity and lower time costs. This is a very complete service, from the
                            idea of the PET preform to the help with the construction of the factory to the life-long after-sales service.
                            If you are looking for a PET preform production line, welcome to contact us! </p>


                    </div>
                </div>
            </div>

        </div>
    );
};

export default Generallyinclude;
